<template>
  <div class="sidebar">
    <div class="main_news" v-if="mainNews.isShow">
      <div class="swiper-container mn_left">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="(item, index) in mainNews.imgList" :key="index">
            <img :src="baseURL + item.imgURL" @click.stop="goDetail1(item.content)" />
            <div class="text_new">
              <p>{{ item.title }}</p>
            </div>
          </div>
        </div>
        <div class="swiper-pagination"></div>
      </div>
      <div class="mn_right" ref="mnRight">
        <!-- <div style="cursor:pointer" @click.stop="goDetail(mainNews.newsid, newsId, 0)">
					<div class="mn_title fs_max" :style="titleWidth">
						<span>{{ mainNews.title }}</span>
					</div>
					<div class="mn_text">
						<span v-html="HTMLDecode(mainNews.partText)"></span>
						...
						<span class="mn_detail">详细内容></span>
					</div>
				</div> -->
        <ul class="mn_list li_wrap">
          <li class="clear" v-for="(item, index) in mainNews.newslist" :key="index" @click.stop="goDetail1(item.content)">
            <span class="li_left overell" style="max-width: 446px">{{ item.title }}</span>
            <span class="li_right">{{ item.date }}</span>
          </li>
        </ul>
      </div>
    </div>
    <div class="bidds_wrap" v-if="biddingObj.isShow">
      <!--招标专区-->
      <div class="bidd_wrap pr">
        <div class="bid_title">
          <img src="@/assets/img/icon_notice.png" />
          <span class="fs_max title">招标专区</span>
        </div>
        <el-tabs v-model="biddingObj.biddingTop" class="tab_wrap2 bidtab2" @tab-click="bidClick">
          <el-tab-pane :label="item.Name" :name="item.Id" v-for="(item, index) in biddingObj.special" :key="index"></el-tab-pane>
        </el-tabs>
        <i class="el-icon-arrow-right" @click.stop="more('#/Bidding')"></i>
        <el-tabs v-model="biddingObj.biddingLeft" tab-position="left" class="tab_wrap" @tab-click="bidLeftClick">
          <el-tab-pane :label="item.Name" :name="item.Value" v-for="(item, index) in purchaseTypes" :key="index"></el-tab-pane>
          <ul class="li_wrap">
            <li class="clear" v-for="(item1, index1) in biddingObj.biddlist1" :key="index1" @click.stop="goDetail(item1.id, item1.cateid, biddingObj.biddingLeft)">
              <span class="li_left overell">{{ item1.title }}</span>
              <span class="li_right">{{ item1.date }}</span>
            </li>
          </ul>
          <div class="noneInfo" v-if="biddingObj.biddlist1.length == 0">sorry，暂时没有信息~</div>
        </el-tabs>
      </div>
      <!--非招标专区-->
      <div class="bidd_wrap pr" v-if="unBiddingObj.isShow">
        <div class="bid_title">
          <img src="@/assets/img/icon_notice.png" />
          <span class="fs_max title">非招标专区</span>
        </div>
        <el-tabs v-model="unBiddingObj.unbiddingTop" class="tab_wrap2 bidtab2" @tab-click="unbidClick">
          <el-tab-pane :label="item.Name" :name="item.Id" v-for="(item, index) in unBiddingObj.nonSpecial" :key="index"></el-tab-pane>
        </el-tabs>
        <i class="el-icon-arrow-right" @click.stop="more('#/UnBidding')"></i>
        <el-tabs v-model="unBiddingObj.unbiddingLeft" tab-position="left" class="tab_wrap" @tab-click="unbidLeftClick">
          <el-tab-pane :label="item.Name" :name="item.Value" v-for="(item, index) in purchaseTypes" :key="index"></el-tab-pane>
          <ul class="li_wrap">
            <li class="clear" v-for="(item1, index1) in unBiddingObj.biddlist2" :key="index1" @click.stop="goDetail(item1.id, item1.cateid, unBiddingObj.unbiddingLeft)">
              <span class="li_left overell">{{ item1.title }}</span>
              <span class="li_right">{{ item1.date }}</span>
            </li>
          </ul>
          <div class="noneInfo" v-if="unBiddingObj.biddlist2.length == 0">sorry，暂时没有信息~</div>
        </el-tabs>
      </div>
      <div class="bidd_wrap pr" v-if="supplierList.isShow">
        <div class="bid_title">
          <img src="@/assets/img/icon_notice.png" />
          <span class="fs_max title">供应商招募</span>
        </div>
        <el-tabs v-model="supplierList.supplierTop" class="tab_wrap2 bidtab2" @tab-click="supplierClick">
          <el-tab-pane :label="item.Name" :name="item.Id" v-for="(item, index) in supplierList.sourcingType" :key="index"></el-tab-pane>
        </el-tabs>
        <i class="el-icon-arrow-right" @click.stop="more('#/Supplier')"></i>
        <el-tabs v-model="supplierList.supplierLeft" tab-position="left" class="tab_wrap" @tab-click="supplierLeftClick">
          <!-- <el-tab-pane label="供应商招募" name="供应商招募"></el-tab-pane> -->
          <el-tab-pane :label="item.Name" :name="item.Value" v-for="(item, index) in purchaseTypes" :key="index"></el-tab-pane>
          <ul class="li_wrap">
            <li class="clear" v-for="(item1, index1) in supplierList.list" :key="index1" @click.stop="goSupplierDetail(item1.id, supplierId, 0)">
              <span class="li_left overell">{{ item1.title }}</span>
              <span class="li_right">{{ item1.date }}</span>
            </li>
          </ul>
          <div class="noneInfo" v-if="supplierList.list.length == 0">sorry，暂时没有信息~</div>
        </el-tabs>

        <!-- <div class="border_wrap" v-if="supplierList.isShow">
					<div class="title">{{ supplierList.title }}</div>
					<ul class="li_wrap">
						<li v-for="(item, index) in supplierList.list" :key="index"
							@click.stop="goDetail(item.id, supplierId, 0)">
							<span class="li_left">{{ item.title }}</span>
							<span class="li_right">{{ item.date }}</span>
						</li>
					</ul>
					<div class="foot" @click.stop="more('#/Supplier')">更多></div>
				</div> -->
      </div>
    </div>
  </div>
</template>

<script>
import Swiper from '@/assets/js/swiper.min.js'

export default {
  data() {
    return {
      titleWidth: {
        width: ''
      },
      initialList: {},
      mainNews: {
        imgList: [],
        title: '',
        partText: '',
        newsid: '',
        newslist: [],
        isShow: true
      },
      biddingObj: {
        special: {},
        biddingTop: '',
        biddingLeft: '',
        biddlist1: [],
        isShow: true
      },
      unBiddingObj: {
        nonSpecial: {},
        unbiddingTop: '',
        unbiddingLeft: '',
        biddlist2: [],
        isShow: true
      },
      supplierId: '',
      supplierList: {
        sourcingType: [],
        title: '供应商招募',
        supplierTop: '',
        supplierLeft: '',
        list: [],
        isShow: true
      },
      newsId: '',
      biddingId: '',
      unBiddingId: '',
      purchaseTypes: {},
      sourcingTypes: [],
      // supplierpurchaseTypes: [{ Name: "全部", Value: "0" }],
      showNum: 7
    }
  },
  props: {
    inidata: {
      type: Object
    }
  },
  watch: {
    inidata: function (newVal, oldVal) {
      this.initialList = newVal
      console.log(this.initialList)
      var type = this.initialList.purchaseTypes[0].Value
      if (this.initialList.supplier != null) {
        this.supplierId = this.initialList.supplier.Id
        this.getList(this.supplierId, type, 3, 0)
      } else {
        this.supplierList.isShow = false
      }

      if (this.initialList.special != null) {
        this.biddingId = this.initialList.special.Id //获取招标专区id
        this.biddingObj.special = this.initialList.special.subCates //获取招投标横向导航栏内容
        this.biddingObj.biddingTop = this.initialList.special.subCates[0].Id //设置招投标默认选中
        this.biddingObj.biddingLeft = this.initialList.purchaseTypes[0].Value //设置全部类别默认选中
        this.getPart(0, this.biddingObj.biddingTop, this.biddingObj.biddingLeft, this.showNum)
      } else {
        this.biddingObj.isShow = false
      }
      // 初始化非招投标
      if (this.initialList.nonSpecial != null) {
        this.unBiddingId = this.initialList.nonSpecial.Id //获取招标专区id
        this.unBiddingObj.nonSpecial = this.initialList.nonSpecial.subCates //获取非招投标横向导航栏内容
        this.unBiddingObj.unbiddingTop = this.initialList.nonSpecial.subCates[0].Id //设置非招投标默认选中
        this.unBiddingObj.unbiddingLeft = this.initialList.purchaseTypes[0].Value //设置类别默认选中
        this.getPart(1, this.unBiddingObj.unbiddingTop, this.unBiddingObj.unbiddingLeft, this.showNum)
      } else {
        this.unBiddingObj.isShow = false
      }
      if (this.initialList.news != null) {
        this.newsId = this.initialList.news.Id //获取新闻id
        this.swiperInit() //初始化轮播图
        this.getMainNews() //初始胡新闻模块
      } else {
        this.mainNews.isShow = false
      }

      // 初始化供应商招募
      if (this.initialList.supplier != null) {
        console.log(this.supplierList)
        this.supplierList.sourcingType = this.initialList.supplier.subCates //获取供应商招募横向导航栏内容
        this.supplierList.supplierTop = this.initialList.supplier.subCates[0].Id //设置供应商招募默认选中
        this.supplierList.supplierLeft = this.initialList.purchaseTypes[0].Value //设置类别默认选中
        this.GetSupplier(this.supplierList.supplierTop, this.supplierList.supplierLeft, this.showNum)
      } else {
        this.supplierList.isShow = false
      }

      this.purchaseTypes = this.initialList.purchaseTypes //获取类别
    }
  },
  mounted() {
    this.widthCom()
  },
  methods: {
    widthCom() {
      let widthh = this.$refs.mnRight.offsetWidth
      this.titleWidth.width = widthh + 'px'
    },
    getMainNews() {
      var that = this
      that
        .getRequest('/Information/GetMain?cateId=' + this.newsId)
        .then((res) => {
          var data = res.data
          var newslist = data.newslist
          if (newslist.length > 0) {
            // that.mainNews.title = newslist[0].title;
            // that.mainNews.newsid = newslist[0].id;
            // that.mainNews.partText = newslist[0].content.substr(0, 110);
            that.mainNews.imgList = data.imgList
            that.mainNews.newslist = newslist
            // for (let i = 1; i < newslist.length; i++) {
            // 	that.mainNews.newslist.push(newslist[i]);
            // }
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    getPart(type, cateId, purchaseType, showNum) {
      var that = this
      let config = {
        params: {
          cateId: cateId,
          purchaseType: purchaseType,
          showNum: showNum
        }
      }
      this.getRequest('/Information/GetPart', config)
        .then((res) => {
          var data = res.data
          if (data.errcode == 0) {
            if (type == 0) {
              that.biddingObj.biddlist1 = data.infoList
            } else if (type == 1) {
              that.unBiddingObj.biddlist2 = data.infoList
            }
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    GetSupplier(sourcingType, purchaseType, showNum) {
      var that = this
      let config = {
        params: {
          cateId: sourcingType,
          purchaseType: purchaseType,
          showNum: showNum
        }
      }
      this.getRequest('/Information/GetSupplierInfo', config)
        .then((res) => {
          var data = res.data
          if (data.errcode == 0) {
            that.supplierList.list = data.infoList
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    swiperInit() {
      setTimeout(() => {
        var mySwiper = new Swiper('.swiper-container', {
          loop: true,
          autoplay: {
            disableOnInteraction: false,
            delay: 4000
          },
          pagination: {
            el: '.swiper-pagination',
            clickable: true
          }
        })
      }, 800)
    },
    bidClick(tab, event) {
      this.biddingObj.biddingTop = tab.name
      this.getPart(0, this.biddingObj.biddingTop, this.biddingObj.biddingLeft, this.showNum)
    },
    bidLeftClick(tab, event) {
      this.biddingObj.biddingLeft = tab.name
      this.getPart(0, this.biddingObj.biddingTop, this.biddingObj.biddingLeft, this.showNum)
    },
    unbidClick(tab, event) {
      this.unBiddingObj.unbiddingTop = tab.name
      this.getPart(1, this.unBiddingObj.unbiddingTop, this.unBiddingObj.unbiddingLeft, this.showNum)
    },
    unbidLeftClick(tab, event) {
      this.unBiddingObj.unbiddingLeft = tab.name
      this.getPart(1, this.unBiddingObj.unbiddingTop, this.unBiddingObj.unbiddingLeft, this.showNum)
    },
    supplierClick(tab, event) {
      this.supplierList.supplierTop = tab.name
      this.GetSupplier(this.supplierList.supplierTop, this.supplierList.supplierLeft, this.showNum)
    },
    supplierLeftClick(tab, event) {
      this.supplierList.supplierLeft = tab.name
      this.GetSupplier(this.supplierList.supplierTop, this.supplierList.supplierLeft, this.showNum)
    },
    publicOfferingClick() {},
    goDetail(id, cateId, purchaseType) {
      let routerData = this.$router.resolve({
        name: 'detail',
        query: {
          id: id,
          cateId: cateId,
          purchaseType: purchaseType
        }
      })
      window.open(routerData.href, '_blank')
    },
    more(url) {
      window.open(url)
    },
    goDetail1(url) {
      window.open(url, '_blank')
    },
    getList(cateId, type, showNum, listType) {
      var that = this
      let config = {
        params: {
          cateId: cateId,
          purchaseType: type,
          showNum: showNum
        }
      }
      this.getRequest('/Information/GetPart', config)
        .then((res) => {
          var data = res.data
          if (data.errcode == 0) {
            if (listType == 0) {
              // that.supplierList.list = data.infoList;
            } else if (listType == 1) {
              that.downLloadList.files = data.infoList
            } else if (listType == 2) {
              that.noticeList.list = data.infoList
            }
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    goSupplierDetail(id, cateId, purchaseType) {
      if (id) {
        let routerData = this.$router.resolve({
          name: 'detail',
          query: { id: id, cateId: cateId, purchaseType: purchaseType }
        })
        window.open(routerData.href, '_blank')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/swiper.min.scss';

.sidebar {
  position: relative;
  height: 100%;
  flex: 3;
  overflow: hidden;
}

.main_news {
  display: flex;

  .mn_left {
    width: 395px;
    max-width: 395px;
    height: 265px;
    flex: 1;
    margin-right: 20px;
    cursor: pointer;
  }

  .mn_right {
    flex: 1.5;

    .mn_title {
      width: 100%;
      padding: 20px 0;

      span {
        width: 85%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        display: inline-block;
      }
    }

    .mn_text {
      color: #666;
      text-indent: 2em;
      line-height: 25px;
      position: relative;

      .mn_detail {
        color: #5a8cb7;
        position: absolute;
        right: 0;
        bottom: 0;
        cursor: pointer;
      }
    }

    .mn_list {
      margin-top: 6px;
    }

    /* .mn_list .li_left{max-width:250px;} */
  }
}

.bidd_wrap {
  margin: 15px 0;
}

.bid_title {
  display: inline-block;
  padding-right: 16px;
  margin: 10px 0;

  .title {
    color: #333;
    font-weight: bold;
    margin-left: 7px;
  }
}

.bidtab2 {
  position: absolute;
  left: 150px;
  top: 10px;
  width: 100%;
}

.el-icon-arrow-right {
  position: absolute;
  right: 0;
  top: 15px;
  cursor: pointer;
}

.status_btn {
  color: #aeaeae;
  border: 1px solid #aeaeae;
  padding: 0 3px;
  margin-left: 10px;
  background: #fff;
  border-radius: 4px;
}

.swiper-slide img {
  width: 100%;
  height: 100%;
}

.tab_wrap2 ::v-deep .el-tabs__header .el-tabs__item.is-active {
  border-bottom: 2px solid #fafafa;
}

.noneInfo {
  line-height: 30px;
  color: #aaa;
  text-align: center;
  margin-top: 30px;
}
</style>